module.exports = __webpack_public_path__ + "img/0.fe8d3c5.png";